// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendRequestFinished__title--VvKSy{font-size:16px;font-weight:700;margin-bottom:20px}.SendRequestFinished__text--ivDP8{text-align:left}`, "",{"version":3,"sources":["webpack://./src/js/components/listing/SendRequestFinished.vue"],"names":[],"mappings":"AAEA,mCACE,cAAA,CACA,eAAA,CACA,kBAAA,CAGF,kCACE,eAAA","sourcesContent":["@use '@/scss/lib/base/variables' as *;\n\n.title {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.text {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `SendRequestFinished__title--VvKSy`,
	"text": `SendRequestFinished__text--ivDP8`
};
module.exports = ___CSS_LOADER_EXPORT___;
